import React from 'react';
const Glitch = ({ text, role = 'text', isActive }) => {
    return (React.createElement("div", { className: isActive ? 'glitch glitchOn' : 'glitch' },
        [...Array(10).keys()].map((i) => (React.createElement("div", { role: role, key: i + 'hg', "aria-hidden": "true", className: "line" }, text))),
        !isActive ? (React.createElement("div", { role: role, className: "line lastLine" }, text)) : null));
};
export default Glitch;
